
import { useState } from "react";
import { Product } from "@/lib/types";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { ScrollArea } from "@/components/ui/scroll-area";
import { sortByUsageAndAlphabet, getProductUsageCount } from "@/lib/services/usageFrequencyService";

interface GroupProductSelectorProps {
  availableProducts: Product[];
  selectedProducts: string[];
  onProductsChange: (productIds: string[]) => void;
}

const GroupProductSelector = ({
  availableProducts,
  selectedProducts,
  onProductsChange,
}: GroupProductSelectorProps) => {
  const handleProductToggle = (productId: string) => {
    onProductsChange(
      selectedProducts.includes(productId)
        ? selectedProducts.filter(id => id !== productId)
        : [...selectedProducts, productId]
    );
  };

  // Sort products by usage frequency
  const sortedProducts = sortByUsageAndAlphabet(availableProducts, 'product', (product) => 
    getProductUsageCount(product.id)
  );

  return (
    <div className="space-y-2">
      <Label>Products</Label>
      {sortedProducts.length > 0 ? (
        <div className="border rounded-md p-3">
          <ScrollArea 
            className="h-[150px]"
            style={{ 
              WebkitOverflowScrolling: 'touch' as const,
              overflowY: 'auto' as const
            }}
          >
            <div className="space-y-2 pr-2">
              {sortedProducts.map((product) => (
                <div key={product.id} className="flex items-center space-x-2 py-1.5">
                  <Checkbox
                    id={`product-${product.id}`}
                    checked={selectedProducts.includes(product.id)}
                    onCheckedChange={() => handleProductToggle(product.id)}
                  />
                  <Label
                    htmlFor={`product-${product.id}`}
                    className="text-sm cursor-pointer leading-tight"
                  >
                    {product.name}
                  </Label>
                </div>
              ))}
            </div>
          </ScrollArea>
        </div>
      ) : (
        <p className="text-sm text-gray-500 dark:text-gray-400">
          No products available. Add some products first!
        </p>
      )}
    </div>
  );
};

export default GroupProductSelector;
